export default function App() {
  return (
    <main className="flex items-center flex-col h-[100vh] bg-[#E5EBED]">
      <p className="error-404 text-[#19A2CC] mt-6 mb-20">Error</p>
      <div class="elementor-heading-title elementor-size-default mt-8">404</div>
      <div class="elementor-widget-container mt-10">
        <p>Looks like someone had an interview with this page, and they aced it so well that it disappeared.&nbsp;</p>						</div>
    </main>
  )
}   